import { useState } from 'react'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useMediaQuery, Box } from '@mui/material'
import UseTranslation from '../../../hooks/UseTranslation'
import { isNotEmpty } from '../../../utils/helpers'

const SeeMoreText = ({ text, customStyle }) => {
  const [expanded, setExpanded] = useState(false)
  const { t } = UseTranslation()
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  const isSmScreen = useMediaQuery((theme) => theme.breakpoints.only('sm'))
  let maxCharacters = null
  if (isXsScreen) {
    maxCharacters = 70
  } else if (isSmScreen) {
    maxCharacters = 180
  }
  const toggleExpansion = () => {
    setExpanded(!expanded)
  }
  return isNotEmpty(text) && (
    <Box sx={customStyle}>
      {((isXsScreen || isSmScreen) && text?.length >= maxCharacters) ? (
        <>
          <Typography
            variant="body1"
            component="span"
            onClick={(e) => e.stopPropagation()}
          >
            {expanded ? text : (
              <>
                {text?.slice(0, maxCharacters)}
                <span>...</span>
              </>
            )}
          </Typography>
          {!expanded && (
          <Box sx={styles.showMoreContainer} onClick={toggleExpansion}>
            <Typography variant="body2">
              {t?.['See More']}
            </Typography>
            <ExpandMoreIcon />
          </Box>
          )}
        </>
      ) : (
        <Typography variant="p1">
          {text}
        </Typography>
      )}
    </Box>
  )
}
const styles = {
  showMoreContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginLeft: '4px',
    '& p': {
      fontSize: { xs: '12px', sm: '14px' },
      color: '#29CC8B',
    },
    '& svg': {
      width: { xs: '20px', sm: '24px' },
      height: { xs: '20px', sm: '24px' },
      color: '#29CC8B',
    },
  },
}
export default SeeMoreText
